export default __webpack_public_path__ + "static/media/serpentesMain.75ad8798.png";